import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ThermoPackage } from '../../../models';
import { IThermoPackageService, ILoggerService } from '../../../services';

class ThermoPackagesListController implements angular.IComponentController {
    isLoading: boolean;
    items: ThermoPackage[];

    static $inject = ['$state', '$translate', 'thermoPackageService', 'loggerService'];

    constructor(
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService,
        private _thermoPackageService: IThermoPackageService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.isLoading = true;
        this._thermoPackageService
            .getAll()
            .then(data => {
                const packages = data.map(item => item.packageInformation);
                if (_.some(packages) && _.every(packages, p => p.comments === 'Not available')) {
                    this._loggerService.logWarning('Thermo packages could not be properly loaded.');
                }
                this.items = packages;
                if (!packages?.length) {
                    const msg = this._$translate.instant('No thermodynamic package defined');
                    this._loggerService.logWarning(msg);
                }
            })
            .catch(reason => {
                this._loggerService.logError(reason?.message ?? reason);
            })
            .finally(() => this.isLoading = false);
    }

    selectItem(item: ThermoPackage, $event: angular.IAngularEvent): void {
        this._$state.go('thermoPackage', { name: item.name });
    }
}

export const wtThermoPackagesList: ComponentDefinition = {
    componentId: 'wtThermoPackagesList',
    controller: ThermoPackagesListController,
    template: require('./thermoPackagesList.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
